import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const productsAndServicesSubNav: RouteListItem[] = [
  {
    path: '/products-and-services/$id',
    icon: UserCircle,
    name: 'Product & Service',
  },
];
